export const STATE_OPTIONS = [
  { key: "all", label: "All" },
  { key: "TX", label: "Texas" },
  { key: "OK", label: "Oklahoma" },
];

export const StateToggle = ({ value, onChange, counts, className = "", idPrefix = "state-toggle" }) => (
  <div
    data-testid={idPrefix}
    className={`flex items-center gap-1 bg-slate-900/85 backdrop-blur-xl border border-white/10 rounded-full shadow-2xl p-1 ${className}`}
  >
    {STATE_OPTIONS.map((o) => (
      <button
        key={o.key}
        data-testid={`${idPrefix}-${o.key}`}
        onClick={() => onChange(o.key)}
        className={`px-4 py-1.5 rounded-full text-xs font-semibold transition-colors duration-200 whitespace-nowrap ${
          value === o.key ? "bg-white text-[#0B132B]" : "text-slate-300 hover:bg-white/10"
        }`}
      >
        {o.label}
        <span className="ml-1.5 font-mono text-slate-500">{counts[o.key] ?? 0}</span>
      </button>
    ))}
  </div>
);
